<template>
    <div class="view-qualify-step-results-machines products-research-view">
        <div class="wrapper">
            <div class="main-title">
                {{ $tc('select_up_to_x_machines', maxResultSelection) }}
            </div>

            <div class="results-header" :class="{'is-flex-wrap-wrap': !isMobile}">
                <div class="column is-half is-two-fifths-desktop filters-and-orders">
                    <div class="action-container">
                        <label class="action-label">
                            {{ $t("filter") }}
                        </label>
                        <div class="action-input">
                            <b-select v-model="selectedFilter" size="is-large" rounded>
                                <option
                                    v-for="option in filters"
                                    :value="option.code"
                                    :key="option.code"
                                >{{ option.label }}</option>
                            </b-select>
                        </div>
                    </div>
                    <div class="action-container" v-if="sortSelector">
                        <label class="action-label">
                            {{ $t("sort") }}
                        </label>
                        <div class="action-input">
                            <b-select v-model="selectedSort" size="is-large" rounded>
                                <option
                                    v-for="option in sorters"
                                    :value="option.code"
                                    :key="option.code"
                                >{{ option.label }}</option>
                            </b-select>
                        </div>
                    </div>
                </div>
                <div class="column is-half is-two-fifths-desktop">
                    <div class="results-count" v-if="filteredResults.length > 0">
                        <span class="is-color-red">{{ filteredResults.length }}</span> {{ $t('search_results') }}
                    </div>
                    <div class="results-count" v-else>
                        <span class="is-color-red">0</span> {{ $t('search_results') }}
                    </div>

                </div>

                <div class="column is-half is-one-fifth-desktop" v-if="selectedFilter">
                    <table class="view-table" align="center">
                        <tr>
                            <td>
                                <label class="is-hidden-desktop">{{ $t('view-choice') }} :</label>
                            </td>
                            <td>
                                <b-button v-on:click="$root.$emit('select_view','card')" class="view-button is-large"
                                          :class="{'selected' : selectedView==='card'}" rounded>
                                    <span class="fa fa-th-large"></span>
                                </b-button>
                            </td>
                            <td>
                                <span class="separator">|</span>
                            </td>
                            <td>
                                <b-button v-on:click="$root.$emit('select_view','row')" class="view-button is-large"
                                          :class="{'selected' : selectedView==='row'}" rounded>
                                    <span class="fa fa-th-list"></span>
                                </b-button>
                            </td>
                        </tr>
                    </table>
                </div>
            </div>

            <div v-if="displayContent">
                <template v-if="selectedView === 'card' || isPhone">
                    <div class="results">
                        <card-machine
                            class="result-item"
                            v-for="result in stepByStepResults"
                            :key="result.identifier"
                            :selectable="true"
                            :disabled-selection="selectedMachineResults.length >= maxResultSelection"
                            :max-select="maxResultSelection"
                            :default-selected="selectedMachineResults"
                            v-model="selectedMachineResults"
                            :datas="result"
                            :class="{'is-bestseller': result.isBestSeller && $store.state.settings.region==='R1','is-new': result.isNew }"
                            @machineSelected="machineSelected($event, result.identifier)"
                        />
                    </div>
                </template>
                <template v-else>
                    <div id="filters" class="columns" v-if="selectedFilter">
                        <div class="column" v-show="false"></div>
                        <div class="column filter is-justify-center"><label @click="selectedSort = 'reference_name'"><strong>Nom machine</strong> <span
                            class="fa fa-sort-amount-down-alt" :class="{'active' : selectedSort === 'reference_name'}"></span></label></div>
                        <div class="column text-center"></div>
                        <div class="category column" v-show="false"></div>
                        <div
                            v-for="attribute in filterAttributes"
                            :key="attribute.code"
                            :label-value="attribute.code"
                            class="column filter"
                        >
                            <b-tooltip :label="attribute.label"
                                     position="is-top">
                                <label @click="selectedSort = attribute.code"><strong>{{ attribute.label.substring(0,40) }}</strong><template v-if="attribute.label.length>40">[...]</template> <span
                                    class="fa fa-sort-amount-down-alt" :class="{'active' : selectedSort === attribute.code}"></span></label>

                            </b-tooltip>
                        </div>
                        <div class="column" style="flex: 0 0 50px;"></div>
                    </div>
                    <div class="results">
                        <card-machine-row
                            v-for="(result, index) in stepByStepResults"
                            :key="result.identifier+'-row'"
                            :style="'order:'+index"
                            :selectable="true"
                            :disabled-selection="selectedMachineResults.length >= maxResultSelection"
                            :max-select="maxResultSelection"
                            :default-selected="selectedMachineResults"
                            :datas="result"
                            :possible-attributes="filterAttributes"
                            :class="{'is-bestseller': result.isBestSeller && $store.state.settings.region==='R1','is-new': result.isNew }"
                            @machineSelected="machineSelected($event, result.identifier)"
                        />
                    </div>
                </template>
            </div>

          <div class="no-results" v-if="filteredResults.length === 0">
            <span class="text">{{ $tc('results_count', 0) }}</span>
            <span class="subtext">{{ $t('please_enlarge_your_filter') }}</span>
          </div>

            <div class="show-more-container" v-if="filteredResults.length !== stepByStepResults.length">
                <button
                    class="button is-black is-large is-rounded is-uppercase"
                    :class="brandBackgroundColor"
                    @click="showMore()"
                >
                    <span>{{ $t("load_more_products") }}</span>
                    <span class="icon-plus is-right-side"></span>
                </button>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapState } from 'vuex'

    import CardMachine from "@/components/Card/CardMachine.vue"
    import CardMachineRow from "@/components/Card/CardMachineRow";

    export default {
        name: 'QualifyIndustryResultsMachines',
        components: {
            CardMachine,
            CardMachineRow
        },
        data(){
            return {
                displayContent: false,
                maxResultSelection: 3,
                selectedFilter: null,
                selectedSort: null,
                sortSelector: false,
                sorters: [
                    {
                        code: null,
                        label: this.$t('select')
                    },
                    {
                        code: 'reference_name',
                        label: this.$t('sort_reference_name')
                    },
                    {
                        code: 'max_capacity',
                        label: this.$t('sort_lifting_capacity')
                    },
                    {
                        code: 'max_lifting_height',
                        label: this.$t('sort_max_lifting_height')
                    },
                ]
            }
        },
        computed: {
            ...mapState({
                isLargeDesktop: state => state.settings.isLargeDesktop,
                isSmallDesktop: state => state.settings.isSmallDesktop,
                isTablet: state => state.settings.isTablet,
                isPhone: state => state.settings.isPhone,
                isMobile: state => state.settings.isMobile,
                asyncCategories: state => state.settings.asyncCategories,
                selectedView: state => state.searchMachines.selectedView,
                machineResults: state => state.qualifyIndustry.machineResults,
                currentStepMachineResults: state => state.qualifyIndustry.currentStepMachineResults,
                unitType:state=>state.settings.unitType,
            }),
            selectedMachineResults: {
                get () { return this.$store.state.qualifyIndustry.selectedMachineResults },
                set (value) { this.$store.commit('qualifyIndustry/setSelectedMachineResults', value) }
            },
            itemsPerStep() {
                if(this.isLargeDesktop)
                    return 20
                if(this.isSmallDesktop)
                    return 16
                if(this.isTablet)
                    return 12
                if(this.isPhone)
                    return 10
                return 18;
            },
            stepByStepResults() {
                return this.filteredResults.slice(0, (this.currentStepMachineResults*this.itemsPerStep));
            },
            filters() {
                let options = [{
                    code: null,
                    label: this.$t('select')
                }];

                if(this.machineResults.length > 0){
                    this.machineResults.forEach(machine => {
                        let checkExist = options.find(x => x.code === machine.family.code);
                        if(!checkExist){
                            if (this.asyncCategories) {
                                let checkCategories = this.asyncCategories.find(x => x.code === machine.family.code);
                                if (!checkCategories) {
                                  checkExist = options.find(x => x.code === 'aerial_work_platforms');
                                  if (machine.family.code === 'AWP') {
                                    if(!checkExist) {
                                      let checkCategories = this.asyncCategories.find(x => x.code === 'aerial_work_platforms');
                                      options.push(checkCategories);
                                    }
                                  }
                                  else {
                                    options.push({
                                      code: machine.family.code,
                                      label: machine.family.label
                                    })
                                  }
                                } else options.push(checkCategories);
                            } else {
                                options.push({
                                  code: machine.family.code,
                                  label: machine.family.label
                                })
                            }
                        }
                    })
                }

                return options;
            },
            filteredResults(){

                let results = _.cloneDeep(this.machineResults);

                if(this.selectedFilter === "aerial_work_platforms") {
                  results = results.filter(machine => machine.family.code === "AWP");
                } else if(this.selectedFilter) {
                  results = results.filter(machine => machine.family.code === this.selectedFilter);
                }


                if(this.selectedSort){
                    results = results.sort((a, b) => {
                        if(this.selectedSort === 'reference_name'){
                            if(a.identifier < b.identifier) { return -1; }
                            if(a.identifier > b.identifier) { return 1; }
                        }/*else if(this.selectedSort === 'max_capacity'){
                            const aValue = a.cardAttributes.liftingCap && a.cardAttributes.liftingCap.value.data[this.unitType].amount !== null ? parseInt(a.cardAttributes.liftingCap.value.data[this.unitType].amount) : 0;
                            const bValue = b.cardAttributes.liftingCap && b.cardAttributes.liftingCap.value.data[this.unitType].amount !== null ? parseInt(b.cardAttributes.liftingCap.value.data[this.unitType].amount) : 0;
                            if(aValue < bValue) { return 1; }
                            if(aValue > bValue) { return -1; }
                        }
                        else if(this.selectedSort === 'max_lifting_height'){
                            const aValue = a.cardAttributes.liftingHeight && a.cardAttributes.liftingHeight.value.data[this.unitType].amount !== null ? parseInt(a.cardAttributes.liftingHeight.value.data[this.unitType].amount) : 0;
                            const bValue = b.cardAttributes.liftingHeight && b.cardAttributes.liftingHeight.value.data[this.unitType].amount !== null ? parseInt(b.cardAttributes.liftingHeight.value.data[this.unitType].amount) : 0;
                            if(aValue < bValue) { return 1; }
                            if(aValue > bValue) { return -1; }
                        }*/
                        else {
                          // Industrialisation for every attributes if exists on machine
                          let aAttribute = a.minimalAttributes.find(attr => attr.code === this.selectedSort);
                          let bAttribute = b.minimalAttributes.find(attr => attr.code === this.selectedSort);
                          if (aAttribute && bAttribute) {
                            const aValue = aAttribute.value.data[this.unitType].amount !== null ? parseInt(aAttribute.value.data[this.unitType].amount) : 0;
                            const bValue = bAttribute.value.data[this.unitType].amount !== null ? parseInt(bAttribute.value.data[this.unitType].amount) : 0;
                            if(aValue < bValue) { return 1; }
                            if(aValue > bValue) { return -1; }
                          }
                        }
                        return 0;
                    })
                }
                else {
                    // Sort by 2 criterias
                    results = results.sort((a, b) => {
                        // Sort by category label
                        if(a.family.label < b.family.label) { return -1; }
                        if(a.family.label > b.family.label) { return 1; }
                        // if same category label we sub-sort by reference_name
                        if(a.identifier < b.identifier) { return -1; }
                        if(a.identifier > b.identifier) { return 1; }
                    })
                }

                return results;
            },
            filterAttributes() {
              if (!this.selectedFilter) return [];
              let checkExist = this.filters.find(x => x.code === this.selectedFilter);
              if (checkExist.filtersList) {
                let list = [];
                checkExist.filtersList.forEach( filter => {
                  if (filter.code !== 'machine_brand' && filter.code !== 'family_subcategory'){
                    list.push(filter)
                  }
                    })
                return list
              }
              return this.filteredResults[0].minimalAttributes.slice(0, 3);
            }
        },
        watch: {
            selectedMachineResults(){
                this.checkNextStepAllowed();
            }
        },
        created() {
            if(!this.$route.query.backward) {
                this.$store.commit('qualifyIndustry/resetMachineResults');
                this.startLoading();
                this.$store.dispatch('qualifyIndustry/fetchMachineResults').finally(() => {
                    this.displayContent = true;
                    this.stopLoading()
                })
            }
            else {
                this.displayContent = true;
            }
        },
        mounted() {
            this.$root.$on('select_view', (view) => {
                this.$store.commit('searchMachines/setView', view)
            })
        },
        methods: {
            machineSelected(state, identifier){
                if(state)
                    this.selectedMachineResults.push(identifier)
                else
                    this.selectedMachineResults = this.selectedMachineResults.filter(x => x !== identifier)
            },
            showMore(){
                this.$store.commit('qualifyIndustry/increaseCurrentStepMachineResults');
            },
            checkNextStepAllowed(){
                this.$store.commit('qualifyIndustry/setNextStepAllowed', (this.selectedMachineResults.length > 0));
            },
        }
    }
</script>

<style lang="scss">
.view-qualify-step-results-machines {
  .no-results {
    flex: 1 1 auto;
    text-align: center;
    margin-top: 60px;
    font-size: 26px;
    color: $medium-grey;

    @media #{$mq_phone} {
      margin-top: 30px;
      margin-bottom: 32px;
    }

    .text {
      display: block;
      font-size: 26px;
      line-height: 28px;
      font-weight: 500;
    }

    .subtext {
      margin-top: 20px;
      display: block;
      font-size: 23px;
      line-height: 23px;
      font-weight: 400;
    }
  }

    .main-title {
        font-size: 23px;
        font-weight: 900;
        line-height: 0.96;
        text-align: center;
    }

    .results-header {
        margin-top: 35px;
    }

    .filters-and-orders {
        display: flex;

        @media #{$mq_phone} {
            display: block;
        }

        .action-container {
            display: flex;
            align-items: center;
            margin: 0;

            @media #{$mq_phone} {
                display: block;
                margin: 0;
            }

            .action-label {
                font-size: 18px;
                color: $medium-grey;
                margin-right: 10px;

                @media #{$mq_phone} {
                    display: block;
                    margin: 20px 0 10px 0;
                }
            }
        }
    }

    #filters {
    width: 100%;
    border-radius: 20px 20px 0 0;
    background: $black;
    color: #ffffff;
    padding: 0 25px 0px;
    align-items: center;


    .filter {
      text-align: center;
      display: flex;

      label {
        cursor: pointer;
        display: flex;
        align-items: center;

        strong {
          text-align: left;
          font-size: 16px;
          display: flex;
          color: #ffffff;
          font-weight: normal;
        }

        span {
          text-align: right;
          display: flex;
          border-radius: 100%;
          background: #ffffff;
          color: $black;
          padding: 8px;
          margin-left: 5px;
          font-size: 18px;

          &.active {
            background: $brand-red;
            color: #ffffff;
          }
        }
      }
    }
  }

    .results {
        width: 100%;
        margin: 30px auto 0 auto;
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        justify-content: left;

        .result-item {
            flex: 0 0 calc((100%/6) - 20px);
            margin: 0 10px 20px 10px;

            @media #{$mq_semilarge_desktop} {
                flex: 0 0 calc((100%/5) - 20px);
            }

            @media #{$mq_large_desktop} {
                flex: 0 0 calc((100%/4) - 20px);
            }

            @media #{$mq_tablet} {
                flex: 0 0 calc((100%/3) - 20px);
            }

            @media #{$mq_phone} {
                flex: 0 0 100%;
                margin: 0 0 20px 0;
            }
        }
    }

    .show-more-container {
        margin-top: 30px;
        text-align: center;
    }
}
</style>
